<template lang="pug">
  .submitForm.container-fuild
    .container 
      h3 产品与服务咨询
      .form 
        .form_li
          img(src="@/assets/img/icon_name.png")
          input(type="text" class="form-control" placeholder="您的称呼" v-model="form.customer_name")
          span.warning(v-show="show.customer_name") 请输入您的称呼
        .form_li
          img(src="@/assets/img/icon_tele.png")
          input(type="text" class="form-control" placeholder="您的联系电话" v-model="form.customer_telephone" @blur="onCheck")
          span.warning(v-show="show.customer_telephone") 请输入您的联系电话
          span.warning(v-show="show.tel_warning") 请输入正确的手机号码
        .form_li
          img(src="@/assets/img/icon_company.png")
          input(type="text" class="form-control" placeholder="您的单位名称" v-model="form.customer_unit")
          span.warning(v-show="show.customer_unit") 请输入您的单位名称
      .submit_btn(@click="submit")
        | 立即提交
        img(src="../assets/img/icon_more_grey.png")
</template>

<script>
import api from '../api/api'

export default {
  name: 'SubmitForm',
  props: {
    origin: {
      type: String,
      default: ''
    }
  },
  data(){
    return {
      show: {
        customer_name: false,
        customer_telephone: false,
        customer_unit: false,
        tel_warning: false
      },
      form: {
        customer_name: '',
        customer_telephone: '',
        customer_unit: '',
        from: 'PC',
        from_page: window.location.href,
        from_page_title: ''
      }
    }
  },
  methods: {
    async submit(){
      this.form.from_page_title = this.origin
      this.form.from = this.$h5 ? 'H5' : 'PC'
      // console.log(this.form, navigator.userAgent)
      this.show.customer_name = this.form.customer_name == '';
      this.show.customer_telephone = this.form.customer_telephone == '';
      this.show.customer_unit = this.form.customer_unit == '';
      if(this.show.customer_name || this.show.customer_telephone || this.show.customer_unit) return;
      if(this.show.tel_warning) return
      let res = await api.boiCreate(this.form)
      if(res.error_code == 0){
        this.$message.success('提交成功');
        this.reset()
      } else {
        this.$message.error(res.error_message);
      }
    },
    reset() {
      this.form = {
        customer_name: '',
        customer_telephone: '',
        customer_unit: '',
        from: 'PC',
        from_page: window.location.href,
      }
    },
    onCheck() {
      var re = /^1[3,4,5,6,7,8,9][0-9]{9}$/;
      var result = re.test(this.form.customer_telephone); 
      if(!result) {
        this.show.tel_warning = true
      } else {
        this.show.tel_warning = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.submitForm {
  // height: 226px;
  background: url('../assets/img/cpjfwzx_bg.png') no-repeat;
  background-size: 100% 100%;
  padding-bottom: 28px;
  box-sizing: border-box;
  h3 {
    color: #fff;
    font-weight: bold;
    text-align: center;
    font-size: 30px;
    margin-top: 30px;
  }

  .form {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-column-gap: 30px;
    grid-row-gap: 30px;
    margin: 36px 0 28px;
    .form_li {
      // width: 370px;
      position: relative;
      height: 36px;
      img {
        position: absolute;
        width: 20px;
        height: 20px;
        left: 18px;
        top: 8px;
      }
      input {
        height: 36px;
        border: 1px solid #DFDFDF;
        border-radius: 0px;
        padding-left: 45px;
        font-size: 16px;
      }
      .warning {
        position: absolute;
        left: 0;
        bottom: -18px;
        font-size: 12px;
        color: red;
      }
    }
  }
  .submit_btn {
    width: 135px;
    height: 36px;
    line-height: 36px;
    color: #6F7783;
    background: #FFFFFF;
    text-align: center;
    margin: 0 auto;
    font-size: 16px;
    cursor: pointer;
    img {
      display: inline-block;
      width: 27px;
      margin-left: 2px;
      margin-bottom: 2px;
    }
  }
}

/* 手机 */
@media screen and (max-width: 768px) {
 .submitForm{
    .form {
      grid-template-columns: 1fr;
      // padding: 0 30px;
    }
 }
}

</style>


// WEBPACK FOOTER //
// src/components/SubmitForm.vue